import normalize from 'components/Dashboard/utilities/normalizeString';
import React from 'react';
import ItemNew from 'components/Dashboard/KeyUpdates/ItemNew';
import ConsultationItem from 'components/Dashboard/ConsultationsSection/consultationItem';
import LegislationItem from 'components/Dashboard/Legislation/LegislationItem';
import ParliamentLiveItem from 'components/Dashboard/ParliamentLive/ParliamentLiveItem';
import CommitteePublicationItem from 'components/Dashboard/CommitteePublication/CommitteePublicationItem';
import ParliamentaryItem from 'components/Dashboard/ParliamentaryRecord/ParlamentaryItem';
import LibraryMaterialItem from 'components/Dashboard/LibraryMaterial/LibraryMaterialItem';
import InfluenceItem from 'components/Dashboard/UserContent/ui/InfluenceListItem';
import TweetItem from 'components/Dashboard/SocialMedia/TweetItem';
import { UpcomingEventItem } from 'components/Dashboard/UpcomingEvents/CalendarSearchRenderFunctions';
import StakeholderItem from 'components/Dashboard/StakeHolders/StakeholderItem';

const ListItem = ({ sectionName, index, commonProperties, item, section, keywordListId, embed }) => {
  const key = embed ? `${sectionName}-item-${index}` : `item-${normalize(sectionName)}-${index}`;
  switch (sectionName) {
    case 'KeyUpdates':
    case 'ElectionKeyUpdates':
    case 'HandPickedKeyUpdates':
      return <ItemNew key={key} switchRelevantExtractOrSummary={embed ? undefined : true} {...commonProperties} />;
    case 'Consultations':
      return (
        <ConsultationItem
          {...commonProperties}
          key={key}
          includeTags={embed ? undefined : true}
          title={embed ? undefined : item?.departmentName}
          isAll={embed ? undefined : !section.totalHits}
        />
      );
    case 'Legislation':
      return (
        <LegislationItem key={key} {...commonProperties} legislationType={embed ? undefined : item?.contentType} />
      );
    case 'ParliamentLive':
      return embed ? (
        <LegislationItem key={key} {...commonProperties} />
      ) : (
        <ParliamentLiveItem key={key} {...commonProperties} />
      );
    case 'RealtimeUtterances':
      return <ParliamentLiveItem key={key} {...commonProperties} />;
    case 'CommitteePublications':
      return (
        <CommitteePublicationItem
          key={key}
          {...commonProperties}
          numberOfContributions={embed ? undefined : section?.collapsedHits[index]?.totalHits}
        />
      );
    case 'ParliamentaryRecord':
      return (
        <ParliamentaryItem
          key={key}
          {...commonProperties}
          numberOfContributions={embed ? undefined : section?.collapsedHits[index]?.totalHits}
        />
      );
    case 'LibraryMaterial':
    case 'CommonsLibraryArticles':
      return (
        <LibraryMaterialItem
          key={key}
          {...commonProperties}
          feedItemFlags={embed ? undefined : section?.feedItemFlags}
        />
      );
    case 'Influence':
    case 'LobbyingMaterial':
      return <InfluenceItem key={key} {...commonProperties} feedItemFlags={section?.feedItemFlags} />;
    case 'SocialMedia':
    case 'Tweets':
      return (
        <TweetItem
          key={key}
          {...commonProperties}
          itemFromWidget={embed ? !!keywordListId : undefined}
          keywordListId={embed ? keywordListId : undefined}
        />
      );
    case 'UpcomingEvents':
      return <UpcomingEventItem key={key} {...commonProperties} />;
    case 'CustomContacts':
      return <StakeholderItem key={key} {...commonProperties} />;
    default:
      return '';
  }
};

export default ListItem;
